"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _translationsContext = require("./translationsContext");
Object.keys(_translationsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _translationsContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _translationsContext[key];
    }
  });
});
//# sourceMappingURL=index.js.map